<div class="pt-3 bg-white py-2 mob_hide">
    <!-- 1st -->
    <div class="col-md-12" *ngIf="travellers && !passengerDetails && !review && !payment && !ticket">
        <div class="row">
            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #e3a32e; color: #e3a32e;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <div [ngClass]="{ 'getActive' : travellers}">
                            <i class="fal fa-plane p-2 label-style" aria-hidden="true"> </i> Review
                        </div>
                    </div>
                </div>
            </a>

            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #D2D2D2; color: #C5C5C5;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <i class="fal fa-users p-2 label-style" aria-hidden="true"></i> &nbsp; Passenger Details
                    </div>
                </div>
            </a>

            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #D2D2D2; color: #C5C5C5;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <i class="fal fa-file-alt p-2 label-style" aria-hidden="true"></i> &nbsp; Trip Summary
                    </div>
                </div>
            </a>

            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #D2D2D2; color: #C5C5C5;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <i class="fal fa-check p-2 label-style" aria-hidden="true"></i> &nbsp; Confirmation
                    </div>
                </div>
            </a>

            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #D2D2D2; color: #C5C5C5;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <i class="fal fa-credit-card p-2 label-style" aria-hidden="true"></i> &nbsp; Payment
                    </div>
                </div>
            </a>
        </div>
    </div>
    <!-- 2nd -->
    <div class="col-md-12" *ngIf="travellers && passengerDetails && !review && !payment && !ticket">
        <div class="row">
            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #e3a32e; color: #e3a32e;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <div [ngClass]="{ 'getDone' : travellers}">
                            <i class="fal fa-plane p-2 label-style" aria-hidden="true"> </i> Review
                        </div>
                    </div>
                </div>
            </a>

            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #e3a32e; color: #e3a32e;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <div [ngClass]="{'getActive': passengerDetails}">
                            <i class="fal fa-users p-2 label-style" aria-hidden="true"></i> &nbsp; Passenger Details
                        </div>
                    </div>
                </div>
            </a>

            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #D2D2D2; color: #C5C5C5;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <i class="fal fa-file-alt p-2 label-style" aria-hidden="true"></i> &nbsp; Trip Summary
                    </div>
                </div>
            </a>

            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #D2D2D2; color: #C5C5C5;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <i class="fal fa-check p-2 label-style" aria-hidden="true"></i> &nbsp; Confirmation
                    </div>
                </div>
            </a>

            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #D2D2D2; color: #C5C5C5;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <i class="fal fa-credit-card p-2 label-style" aria-hidden="true"></i> &nbsp; Payment
                    </div>
                </div>
            </a>
        </div>
    </div>

    <!-- 3rd -->
    <div class="col-md-12" *ngIf="travellers && passengerDetails && review && !payment && !ticket">
        <div class="row">
            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #e3a32e; color: #e3a32e;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <div [ngClass]="{ 'getDone' : travellers}">
                            <i class="fal fa-plane p-2 label-style" aria-hidden="true"> </i> Review
                        </div>
                    </div>
                </div>
            </a>

            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #e3a32e; color: #e3a32e;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <div [ngClass]="{'getDone': passengerDetails }">
                            <i class="fal fa-users p-2 label-style" aria-hidden="true"></i> &nbsp; Passenger Details
                        </div>
                    </div>
                </div>
            </a>

            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #e3a32e; color: #e3a32e;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <div [ngClass]="{'getActive': review }">
                            <i class="fal fa-file-alt p-2 label-style" aria-hidden="true"></i> &nbsp; Trip Summary
                        </div>
                    </div>
                </div>
            </a>

            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #D2D2D2; color: #C5C5C5;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <i class="fal fa-check p-2 label-style" aria-hidden="true"></i> &nbsp; Confirmation
                    </div>
                </div>
            </a>


            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #D2D2D2; color: #C5C5C5;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <i class="fal fa-credit-card p-2 label-style" aria-hidden="true"></i> &nbsp; Payment
                    </div>
                </div>
            </a>
        </div>
    </div>
    <!-- 4th -->
    <div class="col-md-12" *ngIf="travellers && passengerDetails && review && ticket && !payment">
        <div class="row">
            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #e3a32e; color: #e3a32e;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <div [ngClass]="{ 'getDone' : travellers}">
                            <i class="fal fa-plane p-2 label-style" aria-hidden="true"> </i> Review
                        </div>
                    </div>
                </div>
            </a>

            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #e3a32e; color: #e3a32e;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <div [ngClass]="{'getDone': passengerDetails }">
                            <i class="fal fa-users p-2 label-style" aria-hidden="true"></i> &nbsp; Passenger Details
                        </div>
                    </div>
                </div>
            </a>

            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #e3a32e; color: #e3a32e;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <div [ngClass]="{'getDone': review }">
                            <i class="fal fa-file-alt p-2 label-style" aria-hidden="true"></i> &nbsp; Trip Summary
                        </div>
                    </div>
                </div>
            </a>

            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #e3a32e; color: #e3a32e;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <div [ngClass]="{'getActive': ticket }">
                            <i class="fal fa-credit-card p-2 label-style" aria-hidden="true"></i> &nbsp; Confirmation
                        </div>
                    </div>
                </div>
            </a>
            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #D2D2D2; color: #C5C5C5;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <i class="fal fa-check p-2 label-style" aria-hidden="true"></i> &nbsp; Payment
                    </div>
                </div>
            </a>
        </div>
    </div>

    <!-- 5th -->
    <div class="col-md-12" *ngIf="travellers && passengerDetails && review && ticket && payment">
        <div class="row">
            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #e3a32e; color: #e3a32e;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <div [ngClass]="{'getDone': travellers }">
                            <i class="fal fa-plane p-2 label-style" aria-hidden="true"> </i> Review
                        </div>
                    </div>
                </div>
            </a>

            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #e3a32e; color: #e3a32e;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <div [ngClass]="{'getDone': passengerDetails }">
                            <i class="fal fa-users p-2 label-style" aria-hidden="true"></i> &nbsp; Passenger Details
                        </div>
                    </div>
                </div>
            </a>

            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #e3a32e; color: #e3a32e;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <div class="" [ngClass]="{'getDone': review }">
                            <i class="fal fa-file-alt p-2 label-style" aria-hidden="true"></i> &nbsp; Trip Summary
                        </div>
                    </div>
                </div>
            </a>

            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #e3a32e; color: #e3a32e;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <div class="" [ngClass]="{'getDone': ticket }">
                            <i class="fal fa-credit-card p-2 label-style" aria-hidden="true"></i> &nbsp; Confirmation
                        </div>
                    </div>
                </div>
            </a>
            <a href="javascript: void(0);" class="col-sm customCenter"
                style="border-bottom: 5px solid #e3a32e; color: #e3a32e;">
                <div class="d-flex flex-column">
                    <div class="label-style">
                        <div class="" [ngClass]="{'getActive': payment }">
                            <i class="fal fa-check p-2 label-style" aria-hidden="true"></i> &nbsp; Payment
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
</div>